import { Connection, Edge, Handle, Position, useReactFlow } from "reactflow";
import { INode } from "./manager";
import { Tooltip } from "@mui/material";

interface IRequest {
  type: "target" | "source";
  subtype: INode["data"]["subtype"];
  backgroundColor?: string;
  id: string;
  index?: number;
  total?: number;
  tooltip?: string;
}

const MULTI_OUTPUT_NODES = [
  "simpleCondition",
  "compoundCondition",
  "openingHour"
];

export const HandleConexaBot = ({
  type,
  subtype,
  id,
  backgroundColor,
  index = 0,
  total = 1,
  tooltip
}: IRequest) => {
  const { getEdges, getNodes } = useReactFlow();

  const isMultiOutputNode = MULTI_OUTPUT_NODES.includes(String(subtype));

  // Validação: não pode conectar em si mesmo + não pode repetir source
  const isValidConnection = (connection: Connection | Edge) => {
    if (connection.source === connection.target) return false;

    const edges = getEdges();
    const nodes = getNodes();

    const currentNode = nodes.find((nd) => nd.id === connection.source);

    if (
      currentNode &&
      MULTI_OUTPUT_NODES.includes(String(currentNode.data?.subtype))
    ) {
      // Evita múltiplas conexões no mesmo sourceHandle
      const alreadyHas = edges.some(
        (e) => e.sourceHandle === connection.sourceHandle
      );

      return !alreadyHas;
    }

    // Evita múltiplas conexões saindo do mesmo source
    const alreadyHas = edges.some(
      (e) => e.source === connection.source
    );

    return !alreadyHas;
  };

  /**
   * Regras:
   * - Entradas (target) => TOP
   * - Todas as saídas (source) => BOTTOM
   */
  const position =
    type === "target"
      ? Position.Top
      : Position.Bottom;

  // Distribuição dos handles
  const offset = total > 1
    ? (100 / (total + 1)) * (index + 1)
    : 50;

  // Estilos por posição
  const customStyle =
    position === Position.Top
      ? {
          top: 0,
          left: `${offset}%`,
          transform: "translate(-50%, -50%)"
        }
      : {
          bottom: 0,
          left: `${offset}%`,
          transform: "translate(-50%, 50%)"
        };

  const handleElement = (
    <Handle
      id={id}
      type={type}
      position={position}
      style={{
        background: backgroundColor || "#607d8b",
        borderColor: backgroundColor || "#607d8b",
        width: 10,
        height: 10,
        borderRadius: "50%",
        ...customStyle
      }}
      isValidConnection={isValidConnection}
    />
  );

  return tooltip ? (
    <Tooltip title={tooltip}>
      {handleElement}
    </Tooltip>
  ) : (
    handleElement
  );
};